var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkTo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.8574,
    cy: 13.9271,
    r: 13.1572,
    fill: "#392994"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0981 9.22815H14.0904L19.0075 14.2805L14.0904 19.3329H10.0981L15.0377 14.2805L10.0981 9.22815Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkTo);
export default __webpack_public_path__ + "static/media/link-to.f09f6df8995220d86fbd0593846277f8.svg";
export { ForwardRef as ReactComponent };